export enum CourseReserveFilterStatus {
  COURSE_RESERVE = 'course-reserve',
}

export type CourseReserveStatusFilterAndLabel = {
  value: CourseReserveFilterStatus;
  label: string;
};

export const COURSE_RESERVE_STATUS_FILTER: CourseReserveStatusFilterAndLabel = {
  value: CourseReserveFilterStatus.COURSE_RESERVE,
  label: 'Course reserve',
};

export const ALL_COURSE_RESERVE_STATUS_FILTERS: CourseReserveStatusFilterAndLabel[] =
  [COURSE_RESERVE_STATUS_FILTER];
